import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { business, serviceAreas } from '../../data/site';
import { buttonClass } from '../../utils/styles';
import { SectionHeading } from '../SectionHeading';
export function ServiceAreaSection() {
  const {
    t
  } = useLanguage();
  return <section className="bg-mist" aria-labelledby="area-heading" data-id="element-174" data-mp="2if11rnfl25nk">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24" data-id="element-175" data-mp="2nffcxechdvpt">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:gap-16" data-id="element-176" data-mp="2rhk5sav3uobe">
          <div data-id="element-177" data-mp="2w8ilb889ridl">
            <SectionHeading id="area-heading" eyebrow={t({
            en: 'Service area',
            es: 'Área de servicio'
          })} title={t({
            en: 'Serving Dallas-Fort Worth and the surrounding Metroplex',
            es: 'Al servicio de Dallas-Fort Worth y todo el Metroplex'
          })} description={t({
            en: 'Based in Dallas, on the road daily across the Metroplex. If your city is not listed, call us anyway — we travel for the right project.',
            es: 'Con base en Dallas y en camino todos los días por el Metroplex. Si tu ciudad no aparece, llámanos igual — viajamos por el proyecto correcto.'
          })} data-id="element-178" data-mp="2w80ifsr3q5wp" />
            <ul className="mt-8 grid grid-cols-2 gap-x-6 gap-y-2.5 sm:grid-cols-3" data-id="element-179" data-mp="gudzgs0vpbr">
              {serviceAreas.map(city => <li key={city} className="flex items-center gap-2 text-[0.95rem] text-ink/80" data-id="element-180" data-mp="x5a3jcv4tyov">
                  <MapPinIcon className="h-3.5 w-3.5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-181" data-mp="s7qquhe31tz1" />
                  {city}
                </li>)}
            </ul>
            <a href={business.phoneHref} className={buttonClass('navy', 'md', 'mt-8')} data-id="element-182" data-mp="jdlvplrx1wdp">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="1fwt3tbxruyn7" />
              {t({
              en: 'Check your address',
              es: 'Consulta tu dirección'
            })}
            </a>
          </div>

          <div className="overflow-hidden rounded-xl border border-navy/10 bg-white shadow-card" data-id="element-184" data-mp="35dyhv4uie3pd">
            <iframe src={business.mapEmbed} title={t({
            en: 'Map of the Dallas-Fort Worth service area',
            es: 'Mapa del área de servicio de Dallas-Fort Worth'
          })} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="h-[420px] w-full border-0" data-id="element-185" data-mp="3aci5d9or3nju" />
          </div>
        </div>
      </div>
    </section>;
}